import ClosablePageOverlay from './ClosablePageOverlay';
import ChallengeViewCard from './ChallengeViewCard';
import React, { useContext } from 'react';
import { FocusOn } from 'react-focus-on';
import IsGoogleDrivePickerOpenContext from '@/components/FileAttachments/utils/IsGoogleDrivePickerOpenContext';

type PortfolioItemViewCardWithPageOverlayProps = {
  variant: 'challenge' | 'task';
  taskBoardOpen?: boolean;
  onClose: () => void;
  onCloseTaskBoard?: () => void;
  children: React.ReactNode;
};

const PortfolioItemViewCardWithPageOverlay = ({
  variant,
  taskBoardOpen,
  onClose,
  onCloseTaskBoard,
  children,
}: PortfolioItemViewCardWithPageOverlayProps) => {
  const [isGoogleDrivePickerOpen] = useContext(IsGoogleDrivePickerOpenContext);

  // We need to disable the FocusOn when the Google Drive file picker is open
  // to prevent focus fighting
  return (
    <FocusOn enabled={!isGoogleDrivePickerOpen}>
      <ClosablePageOverlay
        variant={variant}
        taskBoardOpen={taskBoardOpen ?? false}
        onClose={onClose}
        onCloseTaskBoard={onCloseTaskBoard}
      >
        <ChallengeViewCard elevation={3} taskBoardOpen={taskBoardOpen ?? false}>
          {children}
        </ChallengeViewCard>
      </ClosablePageOverlay>
    </FocusOn>
  );
};

export default PortfolioItemViewCardWithPageOverlay;
